module.exports = __webpack_public_path__ + "img/icon_yinx.f4efeda9.png";